import { language } from './locale';
import resources from './resources.de.json';

// Keys are original source filenames, before webpack adds a content hash.
export function localizedMedia(originalUrl, filename, locale = language) {
  return locale === 'de' && resources.media[filename] ? resources.media[filename] : originalUrl;
}

// Exact URLs or URL prefixes can be replaced when German external services
// become available. Until then we retain the existing working destinations.
export function localizedLink(originalUrl, locale = language) {
  if (locale !== 'de') return originalUrl;
  const prefix = Object.keys(resources.links).sort((a, b) => b.length - a.length)
    .find(key => resources.links[key] && (originalUrl === key || originalUrl.startsWith(`${key}/`) || originalUrl.startsWith(`${key}?`)));
  return prefix ? resources.links[prefix].replace(/\/$/, '') + originalUrl.slice(prefix.length) : originalUrl;
}
